// App.js
import React, { Suspense, lazy } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Home from "./pages/Home";
import ScrollToTop from "./components/Scroll/ScrollToTop";

// Ağır proje sayfaları sadece ziyaret edilince yüklensin (code-splitting)
const Elidor = lazy(() => import("./components/projects/elidor"));
const Axe = lazy(() => import("./components/projects/axe"));
const Papara = lazy(() => import("./components/projects/papara"));
const Omo = lazy(() => import("./components/projects/omo"));
const Elidortwo = lazy(() => import("./components/projects/elidor2"));
const Unilever = lazy(() => import("./components/projects/unilever"));
const Omotwo = lazy(() => import("./components/projects/omo2"));
const Anıtkabir = lazy(() => import("./components/projects/anıtkabir"));
const Unileverturkey = lazy(() => import("./components/projects/unileverturkey"));
const UnileverNl = lazy(() => import("./components/projects/unilevernl"));

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={4000} />

      <ScrollToTop />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/elidor" element={<Elidor />} />
          <Route path="/axe" element={<Axe />} />
          <Route path="/papara" element={<Papara />} />
          <Route path="/omo" element={<Omo />} />
          <Route path="/elidor2" element={<Elidortwo />} />
          <Route path="/unilever" element={<Unilever />} />
          <Route path="/omotwo" element={<Omotwo />} />
          <Route path="/anıtkabir" element={<Anıtkabir />} />
          <Route path="/unileverturkey" element={<Unileverturkey />} />
          <Route path="/unilevernl" element={<UnileverNl />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
